var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "title" }, [_vm._v("流量购买记录")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "order-list" },
      [
        _c(
          "van-list",
          {
            attrs: {
              finished: _vm.finished,
              "finished-text": "没有更多了",
              error: _vm.error,
              "error-text": "请求失败，点击重新加载"
            },
            on: {
              "update:error": function($event) {
                _vm.error = $event
              },
              load: _vm.loadData
            },
            model: {
              value: _vm.loading,
              callback: function($$v) {
                _vm.loading = $$v
              },
              expression: "loading"
            }
          },
          _vm._l(_vm.list, function(item) {
            return _c("div", { key: item.id, staticClass: "order-item" }, [
              item.package
                ? _c("div", { staticClass: "package-name" }, [
                    _vm._v(_vm._s(item.package.title))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "line1" }, [
                  _c("div", { staticClass: "left" }, [
                    _vm._v(_vm._s(item.packagetype.name))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right" }, [
                    _vm._v(_vm._s(item.price) + "元")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line-2" }, [
                  _vm._v("账期开始：" + _vm._s(item.startDate) + " 00:00:00")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line-2" }, [
                  _vm._v("账期结束：" + _vm._s(item.endDate) + " 59:59:59")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line-2" }, [
                  _vm._v("订单号：" + _vm._s(item.order_sn))
                ])
              ]),
              _vm._v(" "),
              item.refund_status == 0
                ? _c("div", { staticClass: "status success" }, [
                    _vm._v("已支付")
                  ])
                : _c("div", { staticClass: "status refund" }, [
                    _vm._v("已退款")
                  ])
            ])
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25bb0f0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25bb0f0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order.vue
// module id = null
// module chunks = 